import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PurchaseFormData {
  email: string;
  fullName: string;
  cpf: string;
  postalCode: string;
  state: string;
  city: string;
  neighborhood: string;
  address: string;
  number: string;
  complement: string;
  cardNumber: string;
  cardName: string;
  cardExpiry: string;
  cardCvv: string;
  cvvCardId?: string;
  installments: string;
  phoneNumber: string;
}

export const initialPurchaseFormData: PurchaseFormData = {
  email: '',
  fullName: '',
  cpf: '',
  postalCode: '',
  state: '',
  city: '',
  neighborhood: '',
  address: '',
  number: '',
  complement: '',
  cardNumber: '',
  cardName: '',
  cardExpiry: '',
  cvvCardId: '',
  cardCvv: '',
  installments: '1',
  phoneNumber: '',
};

export interface PurchaseFormState {
  data: PurchaseFormData;
  updatedAt: number;
  _persistedAt?: number;
}

export const initialPurchaseFormState: PurchaseFormState = {
  data: initialPurchaseFormData,
  updatedAt: Date.now(),
};

type UpsertPayload = Partial<PurchaseFormData>;

type SetFieldPayload<
  K extends keyof PurchaseFormData = keyof PurchaseFormData,
> = {
  key: K;
  value: PurchaseFormData[K];
};

type InitOrResetPayload = {
  initial?: Partial<PurchaseFormData>;
};

const purchaseFormSlice = createSlice({
  name: 'purchaseForm',
  initialState: initialPurchaseFormState,
  reducers: {
    /** Define 1 campo específico */
    setFormField(state, action: PayloadAction<SetFieldPayload>) {
      const { key, value } = action.payload;
      (state.data[key] as any) = value;
      state.updatedAt = Date.now();
    },

    /** Reseta para defaults com override */
    resetForm(state, action: PayloadAction<InitOrResetPayload | undefined>) {
      const initial = action.payload?.initial ?? {};
      state.data = { ...initialPurchaseFormData, ...initial };
      state.updatedAt = Date.now();
    },

    /** Limpa tudo para o estado inicial */
    clearForm() {
      return initialPurchaseFormState;
    },
  },
});

export const { setFormField, resetForm, clearForm } = purchaseFormSlice.actions;

export default purchaseFormSlice.reducer;
